<template>
  <div class="col-span-full themeTransition">
    <section
      class="col-start-1 col-end-[15] overflow-hidden mt-20 lg:mt-34 grid grid-cols-layout-mobile auto-rows-min gap-x-5 md:gap-x-8 lg:grid-cols-layout lg:gap-x-12 2xl:gap-x-20"
    >
      <div :class="headerClass">
        <header2
          v-if="typeof pageTitle !== 'undefined'"
          :text="pageTitle"
          :isUmbraco="false"
          :theme="themeType"
          classes="mb-5"
        />
      </div>
      <div
        v-if="description"
        class="col-start-2 col-span-12 md:col-span-6 md:col-start-2 mb-[60px]"
      >
        <rich-text
          v-if="description"
          :text="description"
          :isUmbraco="isUmbraco"
          :theme="themeType"
          :isManchet="true"
          classes="md:col-span-6 mb-10 md:mb-12"
        />
      </div>
    </section>
    <section
      class="lg:min-h-[500px] col-start-1 col-end-[15] overflow-hidden mt-20 lg:mt-34 pb-20 lg:pb-34 grid grid-cols-layout-mobile auto-rows-min gap-x-5 md:gap-x-8 lg:grid-cols-layout lg:gap-x-12 2xl:gap-x-20"
    >
      <div
        class="col-start-2 col-span-12 sm:col-start-3 sm:col-span-10 md:col-start-3 md:col-span-4 lg:col-start-3 lg:col-span-5 mb-10 relative flex items-center"
      >
        <search-button
          @click="getQueryResult"
          themeType="light"
          classes="pb-2 absolute z-10 h-fit"
        />
        <clear-button
          v-if="inputValue"
          @handle-clear="clearSearchInput"
          classes="pb-2 h-[18px] w-[18px] absolute right-0 py-auto"
        />
        <label for="search-field" class="sr-only">Search</label>
        <input
          :value="inputValue"
          id="search-field"
          type="text"
          v-model="inputValue"
          @keyup.enter="getQueryResult"
          placeholder="Search"
          :class="inputclass"
        />
      </div>
      <div
        class="flex flex-col sm:flex-row col-start-2 col-span-12 sm:col-start-3 sm:col-span-10 md:col-start-7 md:col-span-6 lg:col-start-8 lg:col-span-5 lg:justify-end mb-10 gap-4 z-10"
      >
        <Filter-component
          v-if="options && options.length > 0"
          :label="dropdownLabel"
          :options="options"
          :theme="themeType"
          :selected-option="selectedOption"
          :selected-array="selectedOptionArray"
          :toggled-state="openFilter.valueOf() === 'category'"
          classes="col-span-8 col-start-6 2xl:col-start-12 2xl:col-span-2 2xl:row-1 2xl:mb-8"
          :total="totalFilters"
          @selectFilterOption="fetchVacancyByCategoryFilter"
          @toggleState="() => toggleFilter('category')"
        />
        <Filter-component
          v-if="options && options.length > 0"
          :label="CountryLabel"
          :options="countryOptions"
          :theme="themeType"
          :selected-option="selectedCountryOption"
          :selected-array="selectedCountryArray"
          :toggled-state="openFilter.valueOf() === 'country'"
          classes="col-span-8 col-start-6 2xl:col-start-12 2xl:col-span-2 2xl:row-1 2xl:mb-8"
          :total="totalLocations"
          @selectFilterOption="fetchVacancyByCountryFilter"
          @toggleState="() => toggleFilter('country')"
        />
        <Filter-component
          v-if="options && options.length > 0"
          :label="LocationLabel"
          :options="locationOptions"
          :theme="themeType"
          :selected-option="selectedLocationOption"
          :selected-array="selectedLocationArray"
          :toggled-state="openFilter === 'location'"
          classes="col-span-8 col-start-6 2xl:col-start-12 2xl:col-span-2 2xl:row-1 2xl:mb-8"
          :total="totalLocations"
          @selectFilterOption="fetchVacancyByLocationFilter"
          @toggleState="() => toggleFilter('location')"
        />
      </div>
      <div
        class="col-start-2 col-span-12 sm:col-start-3 sm:col-span-10 flex justify-between"
      >
        <Paragraph
          :text="totalVacanciesLaber"
          :isUmbraco="false"
          :theme="themeType"
          classes="lg:w-1/5 font-bold text-xs sm:text-sm"
        ></Paragraph>
        <div class="flex flex-col mb-8 sm:flex-row gap-x-6 gap-y-3">
          <FilterClear
            v-if="
              getLabel(selectedOption, dropdownLabel) ||
              getLabel(selectedCountryOption, CountryLabel) ||
              getLabel(selectedLocationOption, LocationLabel)
            "
            :label="ClearFiltersLabel"
            @handleClick="clearFilters"
            classes="md:mr-[10px] "
          />
          <Dropdown-component
            :label="SortLabel"
            :options="sortOption"
            :theme="themeType"
            :selected-option="selectedSortOption"
            removePadding
            total="2"
            @selectOption="fetchVacanciesBySort"
          />
        </div>
      </div>
      <div
        class="col-start-2 sm:col-start-3 gap-3 col-span-full mb-10 lg:mb-[60px] relative overflow-x-auto 2xl:overflow-x-visible no-scrollbar"
      >
        <div class="flex items-center gap-3">
          <FilterTag
            v-for="(option, index) in selectedOptionArray"
            :label="option"
            :theme="'light'"
            classes="flex items-center after:content-['✖'] after:text-xs after:pl-2 shrink-0 md:last:mr-8 lg:last:mr-92"
            :isClearButton="true"
            @handleClick="() => clearOptionTag(option, 'jobcategory')"
          />
          <FilterTag
            v-for="(country, index) in selectedCountryArray"
            :label="country"
            :theme="'light'"
            :isClearButton="true"
            classes="flex items-center after:content-['✖'] after:text-xs after:pl-2 shrink-0 md:last:mr-8 lg:last:mr-92"
            @handleClick="() => clearCountryTag(country, 'country')"
          />
          <FilterTag
            v-for="(location, index) in selectedLocationArray"
            :label="location"
            :theme="'light'"
            :isClearButton="true"
            classes="flex items-center after:content-['✖'] after:text-xs after:pl-2 shrink-0 md:last:mr-8 lg:last:mr-92"
            @handleClick="() => clearLocationTag(location, 'location')"
          />
        </div>
        <div v-if="!noVacanciesLabeler" class="mt-5">
          <div
            class="[&_a]:text-orange text-aubergine [&_*]:text-aubergine"
            v-if="noVacancyText"
            v-html="noVacancyText"
          ></div>
          <!-- <rich-text
            v-if="noVacancyText"
            :text="noVacancyText"
            :isUmbraco="isUmbraco"
            :theme="themeType"
            :isManchet="false"
            :isSmall="true"
            classes="md:col-span-6 mb-10 md:mb-12"
          /> -->
        </div>
      </div>

      <div class="col-start-3 gap col-span-10 flex mb-2">
        <Paragraph
          :text="PositionLabel"
          :isUmbraco="false"
          :theme="themeType"
          classes="w-1/2 opacity-50 hidden md:block"
        ></Paragraph>
        <Paragraph
          :text="LocationLabel"
          :isUmbraco="false"
          :theme="themeType"
          classes="w-1/5 opacity-50 hidden md:block"
        ></Paragraph>
        <Paragraph
          v-if="vacancyType != 'noDeadline'"
          :text="ApplicationDeadlineLabel"
          :isUmbraco="false"
          :theme="themeType"
          classes="opacity-50 hidden md:block"
        ></Paragraph>
      </div>
      <div
        v-if="!vacancyLoaded"
        class="col-start-2 col-span-12 flex items-center justify-center py-10 min-h-[50vh]"
      >
        <div class="spinner" />
      </div>
      <div
        v-else
        class="flex flex-col md:flex-row col-start-2 col-span-12 sm:col-start-3 sm:col-span-10"
        v-for="(vacancy, index) in results?.results"
        :key="vacancy.reqId"
      >
        <VacancyListItem
          :name="vacancy.title"
          :country="getCountry(vacancy)"
          :closingDate="vacancy.closingDate"
          :theme="themeColor"
          :refId="vacancy.reqId"
          :index="index"
          :pageUrl="vacancyPage"
          :locationLabel="LocationLabel"
          :applicationDeadlineLabel="ApplicationDeadlineLabel"
          :type="vacancyType"
          :locations="vacancy.locations"
        ></VacancyListItem>
      </div>
      <div
        class="flex col-start-2 col-span-12 sm:col-start-3 sm:col-span-10 justify-center my-7"
      >
        <custom-button
          v-if="showLoadMore"
          label="See more"
          theme="light"
          type="secondary"
          @handleClick="HandePager()"
        />
      </div>
    </section>
    <div class="col-span-full" v-if="sections && sections.length > 0">
      <div v-for="(section, index) in sections" :key="index">
        <component
          v-if="section"
          :is="getComponent(section.name as ComponentType)"
          :ref="section.name"
          v-bind="{ ...section.props }"
        ></component>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Header2 from "@components/Typography/Header2.ce.vue";
import Paragraph from "@/components/Typography/Paragraph.ce.vue";
import VacancyListItem from "@/components/Atoms/Vacancy/VacancyListItem.vue";
import RichText from "@components/Typography/RichText.ce.vue";
import { IvacancyResult } from "@/types/components/IVacancyResultData";
import CustomButton from "@atoms/Button/CustomButton.ce.vue";
import FilterTag from "@atoms/FilterTag/FilterTag.ce.vue";
import SearchButton from "@atoms/SearchField/SearchButton.vue";
import ClearButton from "@atoms/SearchField/ClearButton.vue";
import FilterClear from "@atoms/FilterClear/FilterClear.ce.vue";
import { toRefs, onMounted, ref, watch, computed, onBeforeMount } from "vue";
import {
  getVacanciesPage,
  getVacancyCategories,
  getTranslations,
  getVacencyCountries,
  getVacancyLocations,
  getVacancyViewPage,
  getVacanciesFromAnkiro,
} from "@/util/api";
import { IVacancyPage } from "@/types/IVacancyPage";
import { defineProps } from "vue";
import { getComponent, getComponentData } from "@/util/getComponent";
import { ComponentType } from "@/util/constants";
import {
  parseUrl,
  getThemeType,
  addQueryParamToUrl,
  getQueryParameters,
  removeQueryParameters,
  removeQueryParameterByName,
  addMultipleQueryParamsToUrl,
  removeQueryParameterByNameAndLabel,
} from "@/util/helper";
import { Theme } from "@/types/types";
import DropdownComponent, { Option } from "@/components/Atoms/Dropdown/Dropdown.ce.vue";
import FilterComponent from "@/components/Atoms/Dropdown/Filterdropdown.ce.vue";
import { IVacancyResultData } from "@/types/components/IVacancyResultData";

const props = defineProps<{ pageId: string }>();
const { pageId } = toRefs(props);
("");
const openFilter = ref<OpenFilterType>("none");
const pageData = ref<IVacancyPage | null>(null);
const vacancyPage = ref<string>("");
const urlParams = ref<String[] | null>(null);
const currentUrl = ref<string | null>(null);
const isPreview = ref<boolean>(false);
const previewUrl = ref<string>("");
const vacancyList = ref<IVacancyResultData>();
const results = ref<IVacancyResultData | null>(null);
const pageNumber = ref<number>(1);
const pageSizes = ref<number>(10);
const totalPages = ref<number>(0);
const theme = ref<Theme>("sand");
const optionList = ref<string[] | null>(null);
const countryList = ref<string[] | null>(null);
const locationList = ref<string[] | null>(null);
const selectedOption = ref<Option | null>(null);
const selectedOptionArray = ref<string[]>([]);
const toggledState = ref<boolean>(false);
const selectedLocationOption = ref<Option | null>(null);
const selectedLocationArray = ref<string[]>([]);
const selectedCountryOption = ref<Option | null>(null);
const selectedCountryArray = ref<string[]>([]);
const selectedSortOption = ref<Option | null>(null);
const dropdownLabel = ref<string>("");
const PositionLabel = ref<string>("");
const LocationLabel = ref<string>("");
const CountryLabel = ref<string>("");
const SortLabel = ref<string>("");
const ClearFiltersLabel = ref<string>("");
const ApplicationDeadlineLabel = ref<string>("");
const defaultCategoryOption = ref<Option | null>(null);
const defaultLocationOption = ref<Option | null>(null);
const defaultCountryOption = ref<Option | null>(null);
const defaultSortOption = ref<Option | null>(null);
const totalPageText = ref<string>("");
const noVacanciestext = ref<string>("");
const hasVacancy = ref<boolean>(false);
const totalFilters = ref<number>(0);
const totalCountries = ref<number>(0);
const totalLocations = ref<number>(0);
const vacancyLoaded = ref<boolean>(false);
const startIndex = ref(0);
const state = ref<boolean>(false);
const vacancyType = ref<string>("");
const isUmbraco = false;
const inputValue = ref("") || "";

type Emits = {
  (e: "getQueryResult", inputValue: string): void;
};

type OpenFilterType = "none" | "category" | "country" | "location";

const emit = defineEmits<Emits>();

const fetchInitialData = async () => {
  urlParams.value = parseUrl(window.location.href).params;
  pageData.value = await fetchPage();
  currentUrl.value = window.location.href;
  vacancyPage.value = await getVacancyViewPage(isPreview.value);
  vacancyType.value = (await pageData.value?.properties?.vacancyType) || "";

  GetQuery();

  const url = new URL(window.location.href);
  const urlSearchParams = new URLSearchParams(url.search);
  const query = urlSearchParams.get("query");
  inputValue.value = query || "";

  vacancyLoaded.value = true;
  optionList.value = await getVacancyCategories();
  totalFilters.value = optionList.value ? optionList.value.length : 0;
  countryList.value = await getVacencyCountries();
  locationList.value = await getVacancyLocations();
  totalCountries.value = countryList.value ? countryList.value.length : 0;
  totalLocations.value = locationList.value ? locationList.value.length : 0;
  if (!urlParams.value) return;
  let path = urlParams.value.join("/");
  //if path does not contain / replace it with previewUrl.value

  if (window !== window.top) {
    path = previewUrl.value;
    isPreview.value = true;
  }
};

// onBeforeMount(fetchInitialData);

onMounted(async () => {
  await fetchInitialData();
  dropdownLabel.value = await getTranslations("VacancyCategories");
  PositionLabel.value = await getTranslations("VacancyPosition");
  LocationLabel.value = await getTranslations("VacancyLocation");
  CountryLabel.value = await getTranslations("VacancyCountry");
  ClearFiltersLabel.value = await getTranslations("VacancyClearFilter");
  SortLabel.value = await getTranslations("VacancySort");
  ApplicationDeadlineLabel.value = await getTranslations("VacancyDeadline");

  setDefaultOptions();
  const queryParams = getQueryParameters() as Record<string, string>;
  setSelectedOptionsFromQueryParams(queryParams);
});

function setDefaultOptions() {
  defaultCategoryOption.value = {
    All: dropdownLabel.value,
  };
  defaultLocationOption.value = {
    All: LocationLabel.value,
  };
  defaultCountryOption.value = {
    All: CountryLabel.value,
  };
  defaultSortOption.value = {
    "sort-desc": "Most recent",
  };
}

async function fetchPage() {
  return await getVacanciesPage(pageId.value, isPreview.value);
}

watch(pageId, (value) => {
  fetchPage().then((page) => {
    pageData.value = page;
  });
});

// Watch for changes in selectedOptionArray
watch(selectedOptionArray, (newVal, oldVal) => {
  // Perform any additional logic if needed
});

const toggleFilter = (filter: OpenFilterType) => {
  openFilter.value = openFilter.value === filter ? "none" : filter;
};

function setSelectedOptionsFromQueryParams(queryParams: Record<string, string>) {
  function setOption(
    list: any,
    param: string,
    selectedOptionRef: any,
    defaultOption: any,
    selectedArrayRef?: any
  ) {
    const foundOption = list.value?.find((option: any) => option === queryParams[param]);
    //find all the items in the list that are in the queryParams[param]
    const foundOptions = list.value?.filter((option: any) =>
      queryParams[param]?.includes(option)
    );
    //add all the found options to the selectedArrayRef
    if (selectedArrayRef) {
      selectedArrayRef.value = foundOptions;
    }

    selectedOptionRef.value = foundOption
      ? { [foundOption]: foundOption }
      : defaultOption.value;
  }

  setOption(
    countryList,
    "country",
    selectedCountryOption,
    defaultCountryOption,
    selectedCountryArray
  );
  setOption(
    locationList,
    "location",
    selectedLocationOption,
    defaultLocationOption,
    selectedLocationArray
  );
  setOption(
    optionList,
    "jobcategory",
    selectedOption,
    defaultCategoryOption,
    selectedOptionArray
  );
  setOption(sortOption, "sort", selectedSortOption, selectedSortOption);
}

const pageProperties = computed(() => {
  if (!pageData.value) return;
  theme.value = pageData.value.properties.backgroundColor;
  return pageData.value.properties;
});

const sections = computed(() => {
  if (!pageData.value?.properties.grid) return [];
  const sections = pageData.value?.properties.grid.items.map((item) => {
    const { content } = item;
    if (!content) return;
    return getComponentData(content);
  });
  const sanitizedSections = sections.filter(Boolean);

  return sanitizedSections;
});

const totalVacanciesLaber = computed(() => {
  totalPageText.value = `${totalPages.value} open vacancies`;
  return totalPageText.value;
});

const noVacanciesLabeler = computed(() => {
  hasVacancy.value = totalPages.value == 0 ? false : true;
  return hasVacancy.value;
});

const themeColor = computed(() => {
  if (!pageData.value || !theme.value) return "sand";
  return theme.value;
});

const themeType = computed(() => {
  if (!pageData.value || !theme.value) return "light";
  return getThemeType(theme.value);
});

const pageTitle = computed(() => {
  if (!pageData.value && !pageProperties?.value?.title) return "Vacancies";
  return pageProperties?.value?.title;
});

const description = computed(() => {
  if (!pageData.value && !pageProperties?.value?.description?.markup) return "";
  return pageProperties?.value?.description?.markup;
});

const noVacancyText = computed(() => {
  if (!pageProperties?.value?.noVacancyText?.markup) return "";
  return pageProperties?.value?.noVacancyText?.markup;
});

const pagination = computed(() => {
  if (!vacancyList.value) return [];
  return vacancyList.value.results;
});

// Query
const getQueryResult = async () => {
  addQueryParamToUrl("query", inputValue.value);
  startIndex.value = 0;
  addQueryParamToUrl("page", "0");
  GetQuery();
};

//Categry filter
const fetchVacancyByCategoryFilter = async (option: Option) => {
  let queryparameter = Object.values(option)[0];
  if (selectedOptionArray.value.includes(queryparameter)) {
    if (selectedOptionArray.value.length === 1) {
      removeQueryParameterByName("jobcategory");
      startIndex.value = 0;
      addQueryParamToUrl("page", "0");
      GetQuery();
      selectedOption.value = null;
      selectedOptionArray.value = [];
      return;
    } else {
      selectedOptionArray.value = selectedOptionArray.value.filter(
        (item) => item !== queryparameter
      );
      removeQueryParameterByName("jobcategory");
      selectedOptionArray.value.forEach((item) => {
        addMultipleQueryParamsToUrl("jobcategory", item);
      });
      addQueryParamToUrl("page", "0");
      startIndex.value = 0;
      GetQuery();
      selectedOption.value = option;
      return;
    }
  }

  selectedOptionArray.value.push(queryparameter);
  addQueryParamToUrl("page", "0");
  addMultipleQueryParamsToUrl("jobcategory", queryparameter);
  startIndex.value = 0;
  GetQuery();
  selectedOption.value = option;
};

//Location filter
const fetchVacancyByLocationFilter = async (option: Option) => {
  let queryparameter = Object.values(option)[0];
  if (selectedLocationArray.value.includes(queryparameter)) {
    if (selectedLocationArray.value.length === 1) {
      removeQueryParameterByName("location");
      startIndex.value = 0;
      addQueryParamToUrl("page", "0");
      GetQuery();
      selectedLocationOption.value = null;
      selectedLocationArray.value = [];
      return;
    } else {
      selectedLocationArray.value = selectedLocationArray.value.filter(
        (item) => item !== queryparameter
      );
      removeQueryParameterByName("location");
      selectedLocationArray.value.forEach((item) => {
        addMultipleQueryParamsToUrl("location", item);
      });
      addQueryParamToUrl("page", "0");
      startIndex.value = 0;
      GetQuery();
      selectedLocationOption.value = option;
      return;
    }
  }

  selectedLocationArray.value.push(queryparameter);
  addQueryParamToUrl("page", "0");
  addMultipleQueryParamsToUrl("location", queryparameter);
  startIndex.value = 0;
  GetQuery();
  selectedLocationOption.value = option;
};

//Country filter
const fetchVacancyByCountryFilter = async (option: Option) => {
  let queryparameter = Object.values(option)[0];
  //check if the queryparameter is in the selectedCountryArray
  if (selectedCountryArray.value.includes(queryparameter)) {
    //if it is the only one in the array, remove it from the query
    if (selectedCountryArray.value.length === 1) {
      removeQueryParameterByName("country");
      startIndex.value = 0;
      addQueryParamToUrl("page", "0");
      GetQuery();
      selectedCountryOption.value = null;
      selectedCountryArray.value = [];
      return;
    } else {
      selectedCountryArray.value = selectedCountryArray.value.filter(
        (item) => item !== queryparameter
      );
      removeQueryParameterByName("country");
      selectedCountryArray.value.forEach((item) => {
        addMultipleQueryParamsToUrl("country", item);
      });
      addQueryParamToUrl("page", "0");
      startIndex.value = 0;
      GetQuery();
      selectedCountryOption.value = option;
      return;
    }
  }

  selectedCountryArray.value.push(queryparameter);
  addQueryParamToUrl("page", "0");
  addMultipleQueryParamsToUrl("country", queryparameter);
  startIndex.value = 0;
  GetQuery();
  selectedCountryOption.value = option;
};

//Sort filter
const fetchVacanciesBySort = async (option: Option) => {
  let queryparameter = Object.values(option)[0];
  addQueryParamToUrl("sort", queryparameter);
  startIndex.value = 0;
  addQueryParamToUrl("page", "0");
  GetQuery();
  selectedSortOption.value = option;
};

// make a function that recieves two parameters and removes the selected location tag from the selectedLocationArray and the query
const clearLocationTag = async (location: string, filter: string) => {
  selectedLocationArray.value = selectedLocationArray.value.filter(
    (item) => item !== location
  );
  removeQueryParameterByNameAndLabel(filter, location);
  addQueryParamToUrl("page", "0");
  startIndex.value = 0;
  GetQuery();
};

const clearCountryTag = async (country: string, filter: string) => {
  selectedCountryArray.value = selectedCountryArray.value.filter(
    (item) => item !== country
  );
  removeQueryParameterByNameAndLabel(filter, country);
  addQueryParamToUrl("page", "0");
  startIndex.value = 0;
  GetQuery();
};

const clearOptionTag = async (option: string, filter: string) => {
  selectedOptionArray.value = selectedOptionArray.value.filter((item) => item !== option);
  removeQueryParameterByNameAndLabel(filter, option);
  addQueryParamToUrl("page", "0");
  startIndex.value = 0;
  GetQuery();
};

const clearSearchInput = async () => {
  inputValue.value = "";
  // removeQueryParameterByName("query");
  GetQuery();
};

const clearFilters = async () => {
  selectedOption.value = null;
  selectedLocationOption.value = null;
  selectedCountryOption.value = null;
  selectedCountryArray.value = [];
  selectedLocationArray.value = [];
  selectedOptionArray.value = [];
  setDefaultOptions();
  setSelectedOptionsFromQueryParams({});
  removeQueryParameters();
  if (inputValue.value) {
    addQueryParamToUrl("query", inputValue.value);
  }
  GetQuery();
};

const options = computed(() => {
  const categoryOptions = optionList.value?.map((option) => ({ [option]: option })) || [];
  /*
  if (defaultCategoryOption.value) {
    return [defaultCategoryOption.value, ...categoryOptions];
  }
  */
  return categoryOptions;
});

const locationOptions = computed(() => {
  const locationOptions =
    locationList.value?.map((option) => {
      return { [option]: option };
    }) || [];
  /*
  if (defaultLocationOption.value) {
    return [defaultLocationOption.value, ...locationOptions];
  }
  */
  return locationOptions;
});

const countryOptions = computed(() => {
  const countryOptions =
    countryList.value?.map((option) => {
      return { [option]: option };
    }) || [];
  /*
  if (defaultCountryOption.value) {
    return [defaultCountryOption.value, ...countryOptions];
  }
  */
  return countryOptions;
});

function getLabel(option: Record<string, any> | null, comparisonLabel: string): string {
  if (option && Object.values(option)[0] !== comparisonLabel) {
    return Object.values(option)[0];
  }
  return "";
}

const sortOption = computed(() => {
  return [{ "Most recent": "sort-desc" }, { "Oldest first": "sort-asc" }];
});

const inputclass = computed(() => {
  let textTheme =
    themeType.value === "dark" ? "placeholder-white-50" : "placeholder-aubergine";
  return `text-typography flex-grow bg-transparent pb-2 pl-8 font-bold text-nav-s lg:text-l ${textTheme} focus:outline-none border-b-4 border-orange w-full`;
});

const headerClass = computed(() => {
  if (!description.value) return `col-start-2 col-span-12 mt-[80px] mb-[60px]`;
  return `col-start-2 col-span-12 mt-[80px]`;
});

const showLoadMore = computed(() => {
  let pageEnd = pageNumber.value * pageSizes.value;
  if (
    totalPages.value > pageSizes.value &&
    totalPages.value >= pageEnd &&
    startIndex.value + 10 <= totalPages.value
  )
    return true;
  return false;
});

const getCountry = (vacancy: IvacancyResult) => {
  if (!vacancy.country && !vacancy.countries) return "No country specified";
  if (vacancy.country) return vacancy.country;
  if (vacancy.countries) {
    return vacancy.countries;
  }
};

async function HandleQuery() {
  let queryArray = getQueryParameters();
  let query = queryArray["query"] ? (queryArray["query"] as string) : "*";
  let jobcategory = queryArray["jobcategory"]
    ? (queryArray["jobcategory"] as string)
    : "";
  let country = queryArray["country"] ? queryArray["country"] : "";
  let sort = queryArray["sort"] ? (queryArray["sort"] as string) : "sort-desc";
  let pageNr = queryArray["page"] ? parseInt(queryArray["page"] as string) : 1;
  let location = queryArray["location"] ? (queryArray["location"] as string) : "";

  let type = vacancyType.value;
  if (location.includes("ö")) {
    location = location.replace("ö", "ø") as string;
  }
  vacancyList.value = await getVacanciesFromAnkiro(
    type,
    query,
    pageNr,
    sort,
    country,
    jobcategory,
    location
  );

  return vacancyList.value;
}

const HandePager = async () => {
  startIndex.value = startIndex.value === 0 ? 11 : startIndex.value + 10;
  addQueryParamToUrl("page", startIndex.value.toString());
  let addedResult = await HandleQuery();

  if (!results.value && !addedResult) return;
  if (!results.value) results.value = addedResult;
  results.value.results = results.value.results.concat(addedResult.results);
};

const GetQuery = async () => {
  results.value = await HandleQuery();
  totalPages.value = results.value.totalCount;
};
</script>
